// extracted by mini-css-extract-plugin
module.exports = {"root":"Upload_root__1ij04","uploadInput":"Upload_uploadInput__2r4gV"};